export interface FeaturesConfiguration {
  sessionExpiration: boolean;
  waitlist: boolean;
}

export const features: FeaturesConfiguration = {
  sessionExpiration: false,
  waitlist: true,
};
